import {getDatadogRum} from '../../util/datadog/datadogRum';
import {makeTrackEvent} from './makeTrackEvent';

export type TrackArtifactsEvent = {
  action: 'lineage_interaction';
  artifactCollectionName: string;
  artifactTypeName: string;
  entityName: string;
  projectName: string;
  additionalData?: Record<string, unknown>;
};

const trackArtifactsInteraction = makeTrackEvent<
  TrackArtifactsEvent,
  {
    action: {
      description: 'The artifacts interaction action.';
      exampleValues: ['lineage_interaction'];
    };
    artifactCollectionName: {
      description: 'The artifact collection involved in the interaction.';
      exampleValues: ['my-collection'];
    };
    artifactTypeName: {
      description: 'The artifact type involved in the interaction.';
      exampleValues: ['model', 'dataset'];
    };
    entityName: {
      description: 'Entity owning the artifact collection.';
      exampleValues: ['<name>'];
    };
    projectName: {
      description: 'Project owning the artifact collection.';
      exampleValues: ['core-project'];
    };
    additionalData: {
      description: 'Additional contextual properties about the interaction.';
      exampleValues: [{actionDetail: 'node_clicked'; source: 'registry'}];
    };
    _description: 'Tracks user interactions in artifact-specific experiences.';
    _location: 'artifacts pages';
    _motivation: 'Understand artifact interaction patterns and key user actions.';
  }
>('Artifacts Interaction');

export function trackArtifactsEvent(eventData: TrackArtifactsEvent): void {
  trackArtifactsInteraction(eventData);
  getDatadogRum().addAction(`Artifacts.${eventData.action}`, eventData);
}
